import React from 'react';
import cx from 'classnames';

export default function SpinnerFallback({ isCentered }) {
    return (
        <div
            data-component="Spinner"
            className={cx('sarsa-spinner-outer-container', {
                'is-centered': isCentered
            })}>
            <span>Loading</span>
        </div>
    );
}